import { render, staticRenderFns } from "./language-items.vue?vue&type=template&id=42c20a5f&scoped=true&"
import script from "./language-items.vue?vue&type=script&lang=js&"
export * from "./language-items.vue?vue&type=script&lang=js&"
import style0 from "./language-items.vue?vue&type=style&index=0&id=42c20a5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c20a5f",
  null
  
)

export default component.exports